module.exports = __webpack_public_path__ + "static/6323-09fafb92d12fe325b3079811bb26d9af.png";